import {
  DAY,
  LIST,
  PLUS,
  TIMESHEET_CALENDAR,
  TIMESHEET_CARD,
  TIMESHEET_TABLE,
  TIMESHEET_WEEK,
} from "icons";
import { HEADER_CONTENT_PORTAL_ID, UI_ACTION_PORTAL_ID } from "utils";
import { Link, useLocation } from "react-router-dom";

import { Button } from "ui";
import { Icon } from "components";
import NavSlot from "@/components/navigation/tabs";
import { Portal } from "radix-ui";
import { TimesheetHeader } from "@/modules/timesheet/components/header";
import { usePortal } from "hooks";

export default function TimeSheetLogLayout({ children, headerContent }) {
  const { pathname } = useLocation();
  const navItems = [
    {
      id: 1,
      path: "/timesheet/logs",
      label: "Day",
      icon: TIMESHEET_CARD,
    },
    {
      id: 2,
      path: "/timesheet/logs/week",
      label: "Dashboard",
      icon: TIMESHEET_WEEK,
    },
    {
      id: 3,
      path: "/timesheet/logs/calendar",
      label: "Calendar",
      icon: TIMESHEET_CALENDAR,
    },

    {
      id: 4,
      path: "/timesheet/logs/table",
      label: "Table",
      icon: LIST,
    },
  ];
  const uiActionPortal = usePortal({
    elementId: UI_ACTION_PORTAL_ID,
    ownerId: "timesheet-root",
  });

  return (
    <div className="w-full">
      {!pathname.endsWith("logs") && (
        <Portal.Root container={uiActionPortal} className="order-2">
          <Link to="/timesheet/logs/+">
            <Button>
              <Icon icon={PLUS} /> Add Log
            </Button>
          </Link>
        </Portal.Root>
      )}
      <TimesheetHeader>
        {headerContent}
        <div id={HEADER_CONTENT_PORTAL_ID} />
        <NavSlot navItems={navItems} />
      </TimesheetHeader>

      {children}
    </div>
  );
}
